export default "__VITE_ASSET__DxdjG22K__"